<template>
	<div class="page">
		<div class="pageTitleBox" style="align-items: center;">
			<div class="boxNameL">
				{{$route.query.type=='add'?'添加':'编辑'}} 虚拟卡
			</div>
			<el-button type="warning" @click="isBack" size="small">返回</el-button>
			<!-- <div class="boxNameR">
				<el-button type="warning" @click="isBack" size="small">返回</el-button>
			</div> -->
		</div>
		<div class="wrap">
			<el-form ref="form" style="padding-bottom: 80px;" :model="editParams" label-width="100px" :rules='rules'>
				<div class="tit">
					<span class="name">基础设置</span>
				</div>
				<el-form-item label="分类">
					<el-cascader size="mini" filterable ref="cascader" clearable v-model="productTypeIds" :options="categoryData"
					:show-all-levels="true" :props="{ label: 'label',value:'id' }" @change="changeCategory"></el-cascader>
				</el-form-item>
				<el-form-item label="套餐名称" prop="title">
					<el-input v-model="editParams.title" size="mini" style="width: 200px;" placeholder="请输入商品描述"></el-input>
				</el-form-item>
				<el-form-item label="适用品种" prop="applyType">
					<el-radio-group v-model="editParams.applyType">
						<el-radio label="0">通用</el-radio>
						<el-radio label="1">猫用</el-radio>
						<el-radio label="2">犬用</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="虚拟卡级别" prop="level">
					<el-radio-group v-model="editParams.level">
						<el-radio :label="Number(0)">无级别</el-radio>
						<el-radio :label="Number(1)">初级</el-radio>
						<el-radio :label="Number(2)">中级</el-radio>
						<el-radio :label="Number(3)">高级</el-radio>
					</el-radio-group>
				</el-form-item>
				
				<storeSelect v-if='showShops' title='应用门店' :storeIds='storeIds' @sendStore='getStores'></storeSelect>
				<el-form-item label="备注" prop="applyType">
					<el-input style="width: 200px;" type="textarea" autosize placeholder="请输入内容" v-model="editParams.remark" ></el-input>
				</el-form-item>
				<div class="tit">
					<span class="name">设置项目</span>
				</div>
				<el-form-item label="设置使用限制" prop="applyType">
					<el-radio-group v-model="editParams.consumeType">
						<el-radio label="1">不限</el-radio>
						<el-radio label="2">按年</el-radio>
						<el-radio label="3">按季度</el-radio>
						<el-radio label="4">按月</el-radio>
						<el-radio label="5">按周</el-radio>
						<el-radio label="6">自定义天数</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item  label="自定义天数" prop="applyType" v-if="editParams.consumeType=='6'">
					<el-input-number size="mini" v-model="editParams.custom_days" :min="0"  label="描述文字"></el-input-number>
				</el-form-item>
				<el-form-item label="有效天数" prop="applyType" >
					<el-input-number size="mini" v-model="editParams.valid_days" :min="0"  label="描述文字"></el-input-number>
				</el-form-item>
				<el-form-item  label="可消费次数" prop="applyType">
					<el-input-number size="mini" v-model="editParams.total_count" :min="0" @change='handleChange(editParams)'  label="描述文字"></el-input-number>
				</el-form-item>
				
				<div class="tit">
					<span class="name">关联服务</span>
				</div>
				<el-form-item label="">
					<el-button size="small" @click="dialogAddShop_state = true;tree=[{id:'601d11cda93f55b5cf3ae2d1'}]">添加商品</el-button>
				</el-form-item>
				<div style="padding: 0 20px;">
					<el-table :data="editParams.service_details" show-summary>
						<el-table-column prop="service_name" label="服务名称">
						</el-table-column>
						<el-table-column label="规格" width="300px" prop="service_objectName">
							<template slot-scope="scope">
								<el-input size="mini" placeholder="请输入内容" v-model="scope.row.service_objectName" clearable @clear="scope.row.service_objectId=''"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="单价" >
							<template slot-scope="scope">
								<span> {{scope.row.src_price}}</span>
								
							</template>
						</el-table-column>
						<el-table-column label="销售价">
							<template slot-scope="scope">
								<el-input size="mini" style="width: 80px;" placeholder="请输入内容" v-model="scope.row.price" ></el-input>
							</template>
						</el-table-column>
						<el-table-column label="预设总价" prop="total_price">
							<template slot-scope="scope">
								<el-input size="mini" style="width: 80px;" placeholder="请输入内容" v-model="scope.row.total_price" @change="gettotal(scope.row)"></el-input>
							</template>
						</el-table-column>
					<el-table-column label="总价" >
						<template slot-scope="scope">
							<span>{{(scope.row.price*editParams.total_count).toFixed(2)}}</span>
						</template>
					</el-table-column>
						<el-table-column label="操作" width="180px" prop="price">
							<template slot-scope="scope">
								<el-button size="mini" icon="el-icon-delete" type='danger' @click="editParams.service_details.splice(scope.$index,1)"></el-button>
					
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-form>
		</div>
		
		
		
		<div v-if="dialogAddShop_state">
			<dialogNewGoods @closeOn="dialogAddShop_state = false" :addShopState.sync="dialogAddShop_state" :tree="tree" @submit='getgoods'></dialogNewGoods>
		</div>
		<div class="footer">
			<div style="margin: auto;">
				<el-button type="primary" size="small" :loading="loading" @click='submit'>确定</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		setVirtualCardGroup,
		getVirtualCardGroupDl,
		getProductTypeList,
		getProductTypeDl,
	} from '../../../api/productApi.js'
	import dialogNewGoods from "../../../components/dialog_addShop.vue"
	import storeSelect from "../../../components/storeSelect.vue"
	export default{
		components: {
			storeSelect,
			dialogNewGoods
		},
		data(){
			return{
				dialogAddShop_state:false,
				tree:[],
				showShops:true,
				storeIds: [],
				loading:false,
				productTypeIds: '',
				rules: {
					title: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
				},
				categoryData:[],
				editParams:{
					virtualId:'',
					applyType:'0',
					title:'',
					category_info:{
						_id:'',
						name:'',
						code:'',
					},
					level:0,
					valid_days:1,
					total_count:1,
					custom_days:1,
					category_list:[],
					consumeType:'1',
					service_details:[],
					shop_info:[],
					remark:'',
				}
			}
		},
		methods:{
			isBack() {
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.push({
						path: '/fictitious/fictitious'
					})
			
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			// 修改次数
			handleChange(editParams) {
                console.log(editParams,"]]]]]")
				if(editParams.service_details.length>0){
					editParams.service_details.map((item)=>{
					item.price=Number((item.total_price/this.editParams.total_count).toFixed(2))
					console.log(item.price);
				})
				}
				
            },
				// 修改总价
			gettotal(row){
                console.log(row,this.editParams.total_count,"row");
				row.price=Number((row.total_price/this.editParams.total_count).toFixed(2))

			},
			getgoods(data){
				this.editParams.service_details.push({
					detail_id: '',
					service_id: data.goodsItem.serviceId,
					service_name: data.goodsItem.title,
					service_objectId:data.skuItem.service_objectId,
					service_objectName: data.skuItem.service_objectName,
					src_price:data.skuItem.price,
					total_price:data.skuItem.price*this.editParams.total_count,
					price:(data.skuItem.price*this.editParams.total_count)/this.editParams.total_count,
				})
			},
			submit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						setVirtualCardGroup(this.editParams).then(res => {
							if (res.code == 0) {
								this.$message({
									message: '添加成功',
									type: 'success'
								});
								this.$router.push({
									path: '/fictitious/fictitious'
								})
							}
						})
					} else {
						return false;
					}
				});
			},
			getProductTypeList() {
				getProductTypeList({
					category: '虚拟'
				}).then(res => {
					if (res.code == 0) {
						this.categoryData = res.data[0].children[0].children;
						console.log(this.categoryData,"this.categoryData")
			
					}
				})
			},
			getVirtualCardGroupDl(id) {
				this.showShops = false;
				getVirtualCardGroupDl({
					id
				}).then(res => {
					if (res.code == 0) {
						this.editParams = res.data;
						console.log(this.editParams,"this.editParams");
						this.productTypeIds=[this.editParams.category_info._id]
						this.storeIds = this.editParams.shop_info.map(item => {
							return item.shop_id
						})
						
						this.showShops = true;
						
					}
				})
			},
			getStores(data) {
				this.editParams.shop_info = data;
			},
			changeCategory(val) {
				console.log(val,"val");
				if (val.length > 0) {
					getProductTypeDl({
						id: val[val.length - 1]
					}).then(res => {
						if (res.code == 0) {
							this.editParams.category_info._id = res.data._id;
							this.editParams.category_info.name = res.data.name;
							this.editParams.category_list = res.data.parent_all;
						}
					})
				}
			},
		},
		created() {
			this.getProductTypeList()
			if (this.$route.query.id) {
				this.getVirtualCardGroupDl(this.$route.query.id)
			} else {
				this.storeIds = this.$store.state.userInfo.shops.map(item => {
					return item.shop_id
				})
				this.editParams.shop_info = this.$store.state.userInfo.shops
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.page {
		.wrap{
			background-color: #fff;
			padding-bottom: 20px;
		}
		.tit {
			font-size: 16px;
			margin-bottom: 28px;
			height: 40px;
			line-height: 40px;
			border-radius: 3px;
			padding-left: 10px;

			.name {
				padding-left: 5px;
				border-left: 2px solid #F5882A;
			}
		}

		.footer {
			background-color: #fff;
			position: fixed;
			bottom: 0;
			height: 50px;
			line-height: 50px;
			display: flex;
			justify-content: space-between;
			left: 220px;
			right: 0;
			padding-left: 20px;
			z-index: 200;
		}
	}
</style>
